export default __webpack_public_path__ + "static/media/15.7930a41d.jpg";